import React from 'react';
import {IFormFieldItemPropsContext} from '../@interfaces/contexts/IFormFieldItemPropsContext';

export const FormFieldItemPropsContext = React.createContext<IFormFieldItemPropsContext | null>(null);
